import React from 'react'

import SingleAudienceContainer from '../containers/audiences/SingleAudienceContainer'

const SingleAudiencePage = () => {
  return <SingleAudienceContainer />
}

export default SingleAudiencePage
